<template>
  <div class="container">
    <div class="container form-group">
      <label for="customer-select">
        {{ $t("AdminManagement.LicenseIssue.SelectCustomer.Label") }}
      </label>
      <small class="form-text">
        {{ $t("AdminManagement.LicenseIssue.SelectCustomer.Detail") }}
      </small>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <div class="input-group-text">
            <i
              class="fa fa-search"
              aria-hidden="true"
            />
          </div>
        </div>
        <datalist id="select-customer-list">
          <option
            v-for="(words, i) in getAdminCustomerList"
            :key="i"
            :value="words"
          />
        </datalist>
        <input
          id="customer-select"
          type="text"
          class="form-control"
          v-model="selectedCustomerName"
          autocomplete="on"
          list="select-customer-list"
        >
        <div class="input-group-append">
          <button
            type="button"
            class="btn btn-primary"
            :disabled="!selectedCustomerName"
            @click="loadAdminSelectedCustomerHandler()"
          >
            {{ $t("AdminManagement.LicenseIssue.SelectCustomer.Button") }}
          </button>
        </div>
      </div>
    </div>

    <div
      v-show="!selectedCustomer.customerId"
      class="container card-container"
    >
      <div class="card md-12">
        <div class="card-body">
          <h5 class="card-title">
            {{ $t("Setting.CustomerCard.CustomerInfo") }}
          </h5>
        </div>
      </div>
    </div>
    <customer-setting-form
      v-show="selectedCustomer.customerId"
      :customer-setting-data="selectedCustomer"
      @updateEditData="updateEditData"
    />

    <div class="container">
      <button
        type="button"
        class="btn btn-primary btn-block"
        :disabled="isDisabledButton"
        @click="updateAdminCustomerSettingHandler"
      >
        {{ $t("General.Update") }}
      </button>
    </div>

    <div class="container">
      <div class="card md-12">
        <div class="card-body">
          <h5 class="card-title">
            {{ $t("AdminManagement.LicenseIssue.Card.Title") }}
          </h5>
          <p class="card-text">
            <license-purchase-form
              page-type="adminSetting"
              is-controlable
              is-disabled
              @saveAdminPurchasedLicenseAll="saveAdminPurchasedLicenseAll"
            />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerSettingForm from '../../Setting/components/CustomerSettingForm.vue'
import LicensePurchaseForm from './LicensePurchaseForm.vue'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: {
    CustomerSettingForm,
    LicensePurchaseForm
  },
  data: () => ({
    selectedCustomerName: '',
    editData: {}
  }),
  computed: {
    ...mapState('auth', [
      'uid',
    ]),
    ...mapState('auth', [
      'selectedCustomer'
    ]),
    ...mapGetters('auth', [
      'getAdminCustomerList'
    ]),
    isDisabledButton() {
      return !Object.keys(this.editData).length
    }
  },
  methods: {
    ...mapActions([
      'setLoadingState',
      'unsetLoadingState'
    ]),
    ...mapActions('auth', [
      'loadAdminSelectedCustomer',
      'updateAdminCustomerSetting'
    ]),
    loadAdminSelectedCustomerHandler() {
      this.setLoadingState('searchCustomerInfo')
      this.loadAdminSelectedCustomer({
        uid: this.uid,
        name: this.selectedCustomerName
      }).finally(() => {
        this.unsetLoadingState('searchCustomerInfo')
      })
    },
    updateEditData(val) {
      this.editData = Object.assign({}, val)
    },
    updateAdminCustomerSettingHandler() {
      this.setLoadingState('updateCustomerSetting')
      this.updateAdminCustomerSetting({
        uid: this.uid,
        data: this.editData
      }).finally(() => {
        this.unsetLoadingState('updateCustomerSetting')
      })
    },
    saveAdminPurchasedLicenseAll(data) {
      this.setLoadingState('saveAdminPurchasedLicense')
      Promise.all(Object.keys(data.countData.Scheduling).filter((plan) => data.countData.Scheduling[plan] !== 0).map((plan) => {
        const data = {
          customerId: this.selectedCustomer.customerId,
          purchaseType: plan,
          count: Number(data.countData.Scheduling[plan])
        }
        return this.saveAdminPurchasedLicense({
          uid: this.uid,
          data
        })
      })).finally(() => {
        this.unsetLoadingState('saveAdminPurchasedLicense')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
